import { type ReactElement } from 'react';

interface SequenceBannerProps {
  position: number;
  total: number;
  windowHours: number;
  flags: {
    highVolumeFlag: boolean;
    allAbandonedFlag: boolean;
    escalatingSentimentFlag: boolean;
    crossChannelInsistenceFlag: boolean;
  };
}

/**
 * SequenceBanner — Fatia F (ADR-055 §F4.2) — Fase C Brief 2A r7b DS canonical.
 *
 * Banner no topo da Conversa: "Esta é a 3ª conversa em sequência (3 em 24h)".
 * Cores DS v2.3.0 via tokens canônicos (Fase A.1-γ GAP-1 resolved):
 *   - --sequence-danger-*:  escalatingSentimentFlag || allAbandonedFlag.
 *   - --sequence-warning-*: highVolumeFlag || crossChannelInsistenceFlag.
 *   - --sequence-normal-*:  info default.
 *
 * Vide governance/specifications/Brief_2A_V23_r7b_Operational_Specification.md §1.1 GAP-1.
 */
export function SequenceBanner({
  position,
  total,
  windowHours,
  flags,
}: SequenceBannerProps): ReactElement {
  const messages: string[] = [];
  if (flags.highVolumeFlag) {
    messages.push(`${total.toString()} conversas em ${windowHours.toString()}h`);
  }
  if (flags.escalatingSentimentFlag) {
    messages.push('sentimento em queda');
  }
  if (flags.allAbandonedFlag) {
    messages.push('todas anteriores abandonadas');
  }
  if (flags.crossChannelInsistenceFlag) {
    messages.push('multi-canal');
  }

  const severity =
    flags.escalatingSentimentFlag || flags.allAbandonedFlag
      ? 'danger'
      : flags.highVolumeFlag || flags.crossChannelInsistenceFlag
        ? 'warning'
        : 'normal';

  return (
    <div role="alert" className={`sequence-banner sequence-banner--${severity}`}>
      <span className="sequence-banner__title">
        Esta é a {position.toString()}ª conversa em sequência
      </span>
      {messages.length > 0 ? (
        <span className="sequence-banner__meta">· {messages.join(' · ')}</span>
      ) : null}
    </div>
  );
}
